/******/ (() => {
  // webpackBootstrap
  var __webpack_exports__ = {};
  window.PXUTheme.jsAjaxCart = {
    init: function ($section) {
      console.log("[z__jsAjaxCart.js, window.PXUTheme.jsAjaxCart $section: ", $section)
      // Add settings from schema to current object
      window.PXUTheme.jsAjaxCart = $.extend(
        this,
        window.PXUTheme.getSectionData($section)
      );
      if (isScreenSizeLarge() || this.cart_action == 'drawer') {
        this.initializeAjaxCart();
      } else {
        this.initializeAjaxCartOnMobile();
        this.toggleMiniCart();
      }

      if (this.cart_action == 'drawer') {
        this.ajaxCartDrawer = $('[data-ajax-cart-drawer]');

        $(document).on('click', '[data-ajax-cart-trigger]', function (e) {
          e.preventDefault();
          window.PXUTheme.jsAjaxCart.showDrawer();

          return false;
        });
      } else if (this.cart_action == 'mini_cart') {
        this.showMiniCartOnHover();
      }

      $(document).on('click', '.ajax-submit', function (e) {
        e.preventDefault();
        const $addToCartForm = $(this).closest('form');
        window.PXUTheme.jsAjaxCart.addToCart($addToCartForm);

        return false;
      });

      $(document).on('click', '[data-ajax-cart-delete]', function (e) {
        e.preventDefault();
        const lineID = $(this).parents('[data-line-item]').data('line-item');
        window.PXUTheme.jsAjaxCart.removeFromCart(lineID);

        if (window.PXUTheme.jsCart) {
          window.PXUTheme.jsCart.removeFromCart(lineID);
        }

        return false;
      });

      $(document).on('click', '[data-ajax-cart-close]', function (e) {
        e.preventDefault();
        window.PXUTheme.jsAjaxCart.hideDrawer();
        window.PXUTheme.jsAjaxCart.hideMiniCart();

        return false;
      });
    },
    showMiniCartOnHover: function () {
      const $el = $('[data-ajax-cart-trigger]');

      $el.hover(
        function () {
          if (
            window.PXUTheme.theme_settings.header_layout == 'centered' &&
            $('.header-sticky-wrapper').hasClass('is-sticky')
          ) {
            $('.header-sticky-wrapper [data-ajax-cart-trigger]').addClass(
              'show-mini-cart'
            );
            $('.header-cart__toggle-button').attr('aria-expanded', 'true');
          } else {
            $el.addClass('show-mini-cart');
            $('.header-cart__toggle-button').attr('aria-expanded', 'true');
          }
        },
        function (event) {
          // Check if the mouse is leaving the parent element and not over any of its children
          const target = event.target;
          const relatedTarget = event.relatedTarget;
          if (!$(target).has(relatedTarget).length && !$(relatedTarget).is(target)) {
            console.log("Leaving hoverable element: ", $el);
            $el.removeClass('show-mini-cart');
            $('.header-cart__toggle-button').attr('aria-expanded', 'false');
          }
        }
      );
    },
    hideMiniCart: function () {
      if (this.cart_action != 'mini_cart') return false;
      const $el = $('[data-ajax-cart-close]').parents(
        '[data-ajax-cart-trigger]'
      );
      $el.removeClass('show-mini-cart');
      $('.header-cart__toggle-button').attr('aria-expanded', false);
    },
    toggleMiniCart: function () {
      const $el = $('.mobile-header [data-ajax-cart-trigger]');

      // Removes url to the cart page so user is not redirected
      $el.attr('href', '#');
      let touchHandled = false;
      $el.off('touchstart').on('touchstart', function (e) {
        console.log('touched')
        touchHandled = true;
        // If user clicks inside the element, do nothing
        if (e.target.closest('[data-ajax-cart-mini_cart]')) {
          return;
        }
        // Loads content into ajaxCart container for mobile header
        //window.PXUTheme.jsAjaxCart.initializeAjaxCartOnMobile();
        let ajaxCart = document.querySelector('.mobile-icons').querySelector('.header-cart__toggle-button');
        window.coCuratorADA.toggleAjaxCart(ajaxCart, false)
      });

      $el.off('click').on('click', function (e) {
        // If touchstart was just handled, don't handle click
        if (touchHandled) {
            touchHandled = false;
            return;
        }
        console.log("clicked")
        console.log(e.keyCode)
        // space or enter buttons
        if (e.keyCode === 32 || e.keyCode === 13) {
            // Prevent the default behavior of the event (e.g., scrolling the page)
            e.preventDefault();
        }
        window.coCuratorADA.toggleAjaxCart(e.target, false);
    });

       
    },
    showDrawer: function () {
      if (this.cart_action != 'drawer') return false;
      this.ajaxCartDrawer.addClass('is-visible');
      $('.ajax-cart__overlay').addClass('is-visible');
    },
    hideDrawer: function () {
      if (this.cart_action != 'drawer') return false;
      this.ajaxCartDrawer.removeClass('is-visible');
      $('.ajax-cart__overlay').removeClass('is-visible');
    },
    removeFromCart: function (lineID, callback) {
      $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: 'quantity=0&line=' + lineID,
        dataType: 'json',
        success: function (cart) {
          window.PXUTheme.jsAjaxCart.updateView();
        },
        error: function (XMLHttpRequest, textStatus) {
          var response = eval('(' + XMLHttpRequest.responseText + ')');
          response = response.description;
        },
      });
    },
    initializeAjaxCart: function () {
      window.PXUTheme.asyncView
        .load(
          window.PXUTheme.routes.cart_url, // template name
          'ajax' // view name (suffix)
        )
        .done(({ html, options }) => {
          $('[data-ajax-cart-content]').html(html.content);

          // Converting the currencies
          if (window.PXUTheme.currencyConverter) {
            window.PXUTheme.currencyConverter.convertCurrencies();
          }
        })
        .fail(() => {
          // some error handling
        });
    },
    initializeAjaxCartOnMobile: function () {
      //let ajaxCart = document.querySelector('.mobile-icons').querySelector('.header-cart__toggle-button');
      //window.coCuratorADA.toggleAjaxCart(ajaxCart, true)

      window.PXUTheme.asyncView
        .load(
          window.PXUTheme.routes.cart_url, // template name
          'ajax' // view name (suffix)
        )
        .done(({ html, options }) => {
          $('.mobile-header [data-ajax-cart-content]').html(html.content);
        })
        .fail(() => {
          // some error handling
        });
    },
    addToCart: function ($addToCartForm) {
      const $addToCartBtn = $addToCartForm.find('.button--add-to-cart');

      $addToCartForm.removeClass('shopify-product-form--unselected-error');

      if ($addToCartBtn[0].hasAttribute('data-options-unselected')) {
        const cartWarning = `<p class="cart-warning__message animated bounceIn">${window.PXUTheme.translation.select_variant}</p>`;

        $('.warning').remove();

        $addToCartForm
          .addClass('shopify-product-form--unselected-error')
          .find('.cart-warning')
          .html(cartWarning);
        setTimeout(() => {
          $addToCartForm.find('.cart-warning__message').addClass('zoomOut');
        }, 2000);
        $addToCartBtn.removeAttr('disabled').removeClass('disabled');

        $addToCartBtn.find('.icon').removeClass('zoomOut').addClass('zoomIn');

        $addToCartBtn
          .find('span:not(.icon)')
          .text($addToCartBtn.data('label'))
          .removeClass('zoomOut')
          .addClass('zoomIn');
      } else {
        $.ajax({
          url: '/cart/add.js',
          dataType: 'json',
          cache: false,
          type: 'post',
          data: $addToCartForm.serialize(),
          beforeSend: function () {
            $addToCartBtn.attr('disabled', 'disabled').addClass('disabled');

            $addToCartBtn
              .find('span')
              .removeClass('fadeInDown')
              .addClass('animated zoomOut');
          },
          success: function (product) {
            let $el = $('[data-ajax-cart-trigger]');

            $addToCartBtn.find('.checkmark').addClass('checkmark-active');

            // Co-Curator 6/1/2023
            const cartWarning = `<p class="cart-success__message animated bounceIn">${product.title} Added to Cart</p>`;

            $addToCartForm.find('.cart-warning').html(cartWarning);
            // End Co-Curator 6/1/2023

            function addedToCart() {
              if (!isScreenSizeLarge()) {
                $el = $('.mobile-header [data-ajax-cart-trigger]');
                window.PXUTheme.scrollToTop($el);
              } else {
                $el = $('[data-ajax-cart-trigger]');
              }
              //const [mobileHeaderItem, otherItem] = window.coCuratorADA.processItems($el)
              //$el.addClass('show-mini-cart');
              
              let ajaxCart;
              $addToCartBtn.find('span').removeClass('fadeInDown');
              // Co-Curator 1/6/2023 Hide cart Message
              setTimeout(() => {
                $addToCartForm
                  .find('.cart-success__message')
                  .addClass('zoomOut');
                  const isMobile = !window.PXUTheme.media_queries.large.matches
                  if(isMobile){
                    ajaxCart = document.querySelector('.mobile-icons').querySelector('.header-cart__toggle-button');
                  }else{
                    ajaxCart = document.getElementById('reg-ajax-cart-btn')
                  }
                  window.coCuratorADA.toggleAjaxCart(ajaxCart, true)
                  ajaxCart.focus()

              }, 100);
              // End Co-Curator
            }

            window.setTimeout(function () {
              $addToCartBtn.removeAttr('disabled').removeClass('disabled');

              $addToCartBtn.find('.checkmark').removeClass('checkmark-active');

              $addToCartBtn
                .find('.text, .icon')
                .removeClass('zoomOut')
                .addClass('fadeInDown');

              $addToCartBtn.on(
                'webkitAnimationEnd oanimationend msAnimationEnd animationend',
                addedToCart
              );
            }, 1000);

            window.PXUTheme.jsAjaxCart.showDrawer();
            window.PXUTheme.jsAjaxCart.updateView();

            if (window.PXUTheme.jsCart) {
              $.ajax({
                dataType: 'json',
                async: false,
                cache: false,
                dataType: 'html',
                url: '/cart',
                success: function (html) {
                  const cartForm = $(html).find('.cart__form');
                  $('.cart__form').replaceWith(cartForm);
                },
              });
            }
          },
          error: function (XMLHttpRequest) {
            let response = eval('(' + XMLHttpRequest.responseText + ')');
            response = response.description;

            const cartWarning = `<p class="cart-warning__message animated bounceIn">${response.replace(
              'All 1 ',
              'All '
            )}</p>`;

            $('.warning').remove();

            $addToCartForm.find('.cart-warning').html(cartWarning);

            // Co-Curator 6/1/2023
            setTimeout(() => {
              $addToCartForm.find('.cart-warning__message').addClass('zoomOut');
            }, 2000);
            // End Co-Curator

            $addToCartBtn.removeAttr('disabled').removeClass('disabled');

            $addToCartBtn
              .find('.icon')
              .removeClass('zoomOut')
              .addClass('zoomIn');

            $addToCartBtn
              .find('span:not(.icon)')
              .text($addToCartBtn.data('label'))
              .removeClass('zoomOut')
              .addClass('zoomIn');
          },
        });
      }
    },
    updateView: function () {
      const isCartPage = window.location.pathname === '/cart';
      window.PXUTheme.asyncView
        .load(
          window.PXUTheme.routes.cart_url, // template name
          'ajax' // view name (suffix)
        )
        .done(({ html, options }) => {
          const isMobile = !window.PXUTheme.media_queries.large.matches
          let ajaxCart;
          if(isMobile){
            ajaxCart = document.querySelector('.mobile-icons').querySelector('.header-cart__toggle-button');
          }else{
            ajaxCart = document.getElementById('reg-ajax-cart-btn')
          }

          if (options.item_count > 0) {
            const itemList = $(html.content).find('.ajax-cart__list');
            const cartDetails = $(html.content).find(
              '.ajax-cart__details-wrapper'
            );

            $('.ajax-cart__list').replaceWith(itemList);
            $('.ajax-cart__details-wrapper').replaceWith(cartDetails);
            $('.ajax-cart__empty-cart-message').addClass('is-hidden');
            $('.ajax-cart__form').removeClass('is-hidden');
            $('[data-ajax-cart-trigger]').addClass('has-cart-count');
            $('[data-bind="itemCount"]').text(options.item_count);
            if(!isCartPage){
              ajaxCart.focus()
            }          } else {
            $('.ajax-cart__empty-cart-message').removeClass('is-hidden');
            $('.ajax-cart__form').addClass('is-hidden');
            $('[data-ajax-cart-trigger]').removeClass('has-cart-count');
            $('[data-bind="itemCount"]').text('0');
            if(!isCartPage){
              ajaxCart.focus()
            }
          }

          if (window.PXUTheme.currencyConverter) {
            window.PXUTheme.currencyConverter.convertCurrencies();
          }
        })
        .fail(() => {
          // some error handling
        });
    },

    unload: function ($section) {
      // Clear event listeners in theme editor
      $('.ajax-submit').off();
      $('[data-ajax-cart-delete]').off();
    },
  };

  /******/
})();
